module.exports = __webpack_public_path__ + "static/img/font_bg.9852e5e1.png";